import { useLocation } from "react-router-dom";

/**
 * Returns the correct site base path based on whether the current URL
 * is in the legacy (/admin/sites-legacy) or new (/admin/sites) view.
 * Used by shared components that render in both routing contexts.
 */
export function useSiteBasePath(): string {
  const { pathname } = useLocation();
  return pathname.startsWith("/admin/sites-legacy") ? "/admin/sites-legacy" : "/admin/sites";
}
